import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { RichiestaSupportoDTO } from '../../../../models/requests/richiesta-supporto.model';
import { EntiEsecutoriService } from '../../../../services/entiEsecutori.service';

@Component({
  selector: 'app-support-modal',
  templateUrl: './support-modal.component.html',
  styleUrls: ['./support-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    ReactiveFormsModule,
    ToastModule,
    RippleModule
  ],
  providers: [MessageService]
})
export class SupportModalComponent implements OnInit {
  visible: boolean = false;
  supportForm: FormGroup;
  submitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private entiEsecutoriService: EntiEsecutoriService
  ) {
    this.supportForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      oggetto: ['', [Validators.required, Validators.minLength(5)]],
      messaggio: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  ngOnInit(): void {}

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.supportForm.reset();
  }

  onSubmit() {
    if (this.supportForm.valid) {
      this.submitting = true;
      this.supportForm.disable();
      const richiestaSupporto: RichiestaSupportoDTO = {
        email: this.supportForm.value.email,
        oggetto: this.supportForm.value.oggetto,
        messaggio: this.supportForm.value.messaggio,
        enteEsecutoreId: Number(localStorage.getItem("enteId")) || 0
      };
      this.entiEsecutoriService.richiestaSupporto(richiestaSupporto).subscribe({
        next: () => {
          this.submitting = false;
          this.supportForm.enable();
          this.messageService.add({
            severity: 'success',
            summary: 'Messaggio inviato',
            detail: 'Il tuo messaggio è stato inviato con successo. Ti risponderemo al più presto.'
          });
          this.hide();
        },
        error: () => {
          this.submitting = false;
          this.supportForm.enable();
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Si è verificato un errore durante l\'invio del messaggio. Per favore riprova più tardi.'
          });
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Per favore compila correttamente tutti i campi richiesti.'
      });
    }
  }
}
